import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import InCountry from "../../Components/InCountry/InCountry";
import s from "./PASKazakhstan.module.scss";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import CountriesBlueButtons from "../../Components/CountriesBlueButtons/CountriesBlueButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { getKazakhstanDiseaseDetails } from "../../redux/InformationSlice";
import { Link, useParams } from "react-router-dom";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

interface Props {
  navigation: {
    name: string;
    path: string;
  };
}

const PASKazahkstan = () => {
  const dispatch: AppDispatch = useDispatch();
  const disease = useSelector(
    (state: RootState) => state.info.kazakhstanDiseaseDetails,
  );
  const params = useParams();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getKazakhstanDiseaseDetails(Number(params.id)));
  }, [params]);

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Seo
        title="Употребление психоактивных веществ и переезд в Казахстан"
        description="Уголовная ответственность за провоз психоактивных веществ, наркотиков в Казахстан."
        url="https://www.vputi.org/kazakhstan/pas/4"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство Казахстана / Для мигрантов, употребляющих психоактивные вещества",
            path: "/kazakhstan",
          }}
        />

        <ContactButtons />

        <div className={s.inner}>
          <div className={s.inner}>
            <div className={s.text}>
              <div className={s.text_title}>{disease?.title_1}</div>
              <div
                className={s.body}
                dangerouslySetInnerHTML={{ __html: disease?.body_1 ?? "" }}
              ></div>

              <div className={s.body_2_wrapper}>
                <div
                  className={s.body2}
                  dangerouslySetInnerHTML={{ __html: disease?.body_2 ?? "" }}
                ></div>
              </div>
              <div className={s.text_title2}>{disease?.title_3}</div>
              <div
                className={s.yellow_wrapper}
                dangerouslySetInnerHTML={{ __html: disease?.body_3 ?? "" }}
              ></div>
            </div>

            <div className={s.title}>
              {t("Где я могу пройти обследования на родине?")}
            </div>

            <CountriesBlueButtons />
          </div>
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default PASKazahkstan;
